import React from 'react';
import { connect } from 'react-redux';

export default function withTrekPermission(WrappedComp) {
  const mapStateToProps = ({ user, selectedTrek }) => {
    const isLoggedIn = Boolean(user.userId);
    const isLeader = user.isLeader;
    const isDraft = selectedTrek.trek && selectedTrek.trek.is_draft;
    const isPublic = selectedTrek.trek && selectedTrek.trek.is_public;
    const isTemplate = selectedTrek.trek && selectedTrek.trek.is_template;
    // const ownerId = selectedTrek.trek && selectedTrek.trek.owner_id;
    const isOwner = selectedTrek.trek && selectedTrek.trek.is_owner;
    const isFollower = selectedTrek.trek && selectedTrek.trek.is_follower;
    const isGuided = selectedTrek.trek && selectedTrek.trek.is_guided;
    const isGuidedOwner = isLeader && isGuided && isOwner;
    const isFrozen = selectedTrek.trek && selectedTrek.trek.is_frozen;

    return {
      isLoggedIn,
      isTemplate,
      isPublic,
      isDraft,
      isFrozen,
      isOwner,
      isFollower,
      isGuided,
      isLeader,
      isGuidedOwner,
    };
  };
  const ui = props => <WrappedComp {...props} />;
  return connect(mapStateToProps)(ui);
}



// WEBPACK FOOTER //
// ./src/HOCs/withTrekPermission.jsx